import { render, staticRenderFns } from "./ConfirmDialogue.vue?vue&type=template&id=2ff5fb9f&scoped=true"
import script from "./ConfirmDialogue.vue?vue&type=script&lang=js"
export * from "./ConfirmDialogue.vue?vue&type=script&lang=js"
import style0 from "./ConfirmDialogue.vue?vue&type=style&index=0&id=2ff5fb9f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ff5fb9f",
  null
  
)

export default component.exports